import { render, staticRenderFns } from "./BlacklistAddresses.vue?vue&type=template&id=5108942b&"
import script from "./BlacklistAddresses.vue?vue&type=script&lang=ts&"
export * from "./BlacklistAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports